import axios from 'axios';
import uuid from 'uuid/v4';
import moment from 'moment';
import { browserHistory } from 'react-router';
import { getBrowserBunyanInstance } from './clientLoggerHandler';
import serverClientUtil from './serverClientUtil';
import {
  constAPIFailure,
  constChannel,
  constDownload,
  constPrint,
  eventCategory,
} from './clientConstant';
import AppEvents from './../pages/App/AppEvents';
import html2canvass from 'html2canvas';

const loggerHandler = getBrowserBunyanInstance('Template');
const { applicationRoutes } = require('./config/applicationRoutesConfig');
const uniqid = require('uniqid');

const pageNameTableOrg = 'tableOrganizer';

// TODO: Need to validate this logic
let _port;
if (process.env.PORT) {
  _port = process.env.PORT;
} else if (DEVELOPMENT) {
  _port = 8080;
} else {
  _port = 5051;
}
const port = typeof env !== 'undefined' ? env.PORT : _port; // eslint-disable-line no-undef

const CommonUtil = {
  routeTo(routeName, routeVar) {
    let route = routeName;
    if (routeVar) {
      if (Array.isArray(routeVar)) {
        routeVar.forEach((rVar) => {
          for (const i in rVar) {
            route = route.replace(':' + i, rVar[i]);
          }
        });
      } else {
        for (const a in routeVar) {
          route = route.replace(':' + a, routeVar[a]);
        }
      }
      route = route.replace(/[()]/g, '');
    }

    return route;
  },
  /**
   * Replace something like "You have added {0} items in cart" to "You have added 3 items in cart"
   * @param  {[type]} labelStr          [description]
   * @param  {[type]} placeholderValues [description]
   * @return {[type]}                   [description]
   */
  replacePlaceholderValues(labelStr, placeholderValues) {
    for (let x = 0; x < placeholderValues.length; x++) {
      // const placeholder = `{${x}}`;
      const placeholder = '{' + x + '}';

      if (labelStr.indexOf(placeholder) !== -1) {
        /* eslint-disable */
        labelStr = labelStr.replace(placeholder, placeholderValues[x]);
      }
    }
    return labelStr;
  },
  /**
   * Method to return the label value for a key from the state
   * If the label is not present ,return the key itself
   * @param  {[type]} labelState [description]
   * @param  {[type]} labelKey   [description]
   * @return {[type]}            [description]
   */
  getLabel(labelState, labelKey, placeholderValues) {
    let labelValue = labelKey;
    if (
      labelState &&
      labelState[labelKey] &&
      typeof labelState[labelKey] === 'string'
    ) {
      labelValue = labelState[labelKey];
    }
    if (placeholderValues && placeholderValues.length) {
      labelValue = CommonUtil.replacePlaceholderValues(
        labelValue,
        placeholderValues,
      );
    }
    if (labelState && labelState.showKey === true) {
      labelValue = '{' + labelKey + '}-' + labelValue;
    }
    return labelValue || '';
  },

  getCurrency(val, space = false) {
    const curencySymbol = '$';
    const value =
      curencySymbol +
      (space ? ' ' : '') +
      parseFloat(0 + val)
        .toFixed(2)
        .replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
    return value;
  },

  getHtmlCurrency(val) {
    const curencySymbol = '$';
    const amount = parseFloat(0 + val)
      .toFixed(2)
      .replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
      .toString();
    const dotIndex = amount.indexOf('.');
    const value =
      curencySymbol +
      ' ' +
      amount.substr(0, dotIndex) +
      ('<sup>' + amount.substr(dotIndex + 1) + '</sup>');
    return value;
  },

  getError(errorState, errorKey, placeholderValues) {
    let errorValue = errorKey;
    if (
      errorState &&
      errorState[errorKey] &&
      typeof errorState[errorKey] === 'string'
    ) {
      errorValue = errorState[errorKey];
    }
    if (placeholderValues && placeholderValues.length) {
      errorValue = CommonUtil.replacePlaceholderValues(
        errorValue,
        placeholderValues,
      );
    }
    return errorValue || '';
  },
  browserRefresh(e) {
    const dialogText = 'Dialog text here';
    e.returnValue = dialogText;
    return dialogText;
  },
  compareEmail(stringOne, stringTwo) {
    if (stringOne.toLowerCase() === stringTwo.toLowerCase()) {
      return false;
    }
    return true;
  },
  validateEmail(emailId) {
    const emailRegex =
      /^(?=[^@]*[A-Za-z])([a-zA-Z0-9])(([a-zA-ZáéíóúüñÁÉÍÓÚÜÑ0-9])*([-\._\+])?([a-zA-Z0-9]))*@(([a-zA-Z0-9\-])+(\.))+([a-zA-Z]{2,4})$/;
    const regex = new RegExp(emailRegex);
    return regex.test(emailId);
  },

  validateEmailForAddGuest(emailId) {
    if (emailId) {
      const emailRegex =
        /^(?=[^@]*[A-Za-z])([a-zA-Z0-9])(([a-zA-ZáéíóúüñÁÉÍÓÚÜÑ0-9])*([-\._\+])?([a-zA-Z0-9]))*@(([a-zA-Z0-9\-])+(\.))+([a-zA-Z]{2,4})$/;
      const regex = new RegExp(emailRegex);
      return regex.test(emailId);
    }
    return true;
  },

  validatePassword(password) {
    return password.length >= 8;
  },

  isValueAvailable(str) {
    let result = false;
    if (str && str.trim()) {
      result = true;
    }
    return result;
  },

  validateLength(textNeedtoTest, minLength) {
    let result = false;
    if (textNeedtoTest.length >= minLength) {
      result = true;
    }
    return result;
  },

  validateLengthDigitsCP(textNeedtoTest, minLength = 5) {
    let result = false;
    const typeData = !isNaN(textNeedtoTest);

    if (typeData && textNeedtoTest.length === minLength) {
      result = true;
    }
    if (!typeData) {
      result = true;
    }
    return result;
  },

  validateNameForAlphaNumeric(textNeedtoTest, minLength) {
    let result = false;
    let regex = new RegExp('^[A-Za-záéíóúüñÁÉÍÓÚÜÑ0-9 ]*$'); //Alphanumeric
    if (textNeedtoTest.length >= minLength && regex.test(textNeedtoTest)) {
      result = true;
    }
    return result;
  },
  validateName(textNeedtoTest, minLength, allow) {
    let result = false;
    let regex = '';
    if (!allow || allow === 'undefined') {
      regex = new RegExp('^[A-Za-záéíóúüñÁÉÍÓÚÜÑ ]*$'); //NotAllowedSpecialCharacter
    } else {
      regex = new RegExp('^[A-Za-záéíóúüñÁÉÍÓÚÜÑ `]*$'); //AllowedSpecialCharacter
    }
    if (textNeedtoTest.length >= minLength && regex.test(textNeedtoTest)) {
      result = true;
    }
    return result;
  },
  validateNameinEventTools(textNeedtoTest, minLength, allow) {
    let result = false;
    let regex = '';
    regex = new RegExp("^[A-Za-záéíóúüñÁÉÍÓÚÜ '-]*$"); //AllowSpaceWithSpecialCharacter
    if (textNeedtoTest.length >= minLength && regex.test(textNeedtoTest)) {
      result = true;
    }
    return result;
  },

  validatePostalCode(textNeedtoTest) {
    let result = false;
    const regex = new RegExp('^[0-9]{4,5}$');
    if (textNeedtoTest > 0) {
      result = regex.test(textNeedtoTest);
    }
    return result;
  },

  validateNumber(textNeedtoTest, allow) {
    let result = false;
    let regex = '';
    if (!allow || allow === 'undefined') {
      regex = new RegExp('^(?:[0-9]{10}|[0-9]{12})$');
    } else {
      regex = new RegExp('^[A-Za-z0-9]{1,10}$');
    }
    result = regex.test(textNeedtoTest);
    return result;
  },
  validatePhoneNumber(textNeedtoTest) {
    let result = false;
    const regex = new RegExp('^[0-9]{7,8}$');
    result = regex.test(textNeedtoTest);
    return result;
  },
  validatePhoneNumber2(textNeedtoTest) {
    let result = false;
    const regex = new RegExp('^[0-9]{10}$');
    result = regex.test(textNeedtoTest);
    return result;
  },
  validatePhoneCode(textNeedtoTest) {
    let result = false;
    const regex = new RegExp('^[0-9]{2,3}$');
    result = regex.test(textNeedtoTest);
    return result;
  },

  validatempty(textNeedtoTest) {
    let result = false;
    if (textNeedtoTest.length <= 0) {
      result = true;
    }
    return result;
  },
  /**
   * Create a new cookie or update an existing cookie
   * @param  {[string]} name    [cookie name]
   * @param  {[string]} value   [cookie value]
   * @param  {[number]} days    [expiry time in days(optional): if not passed, then this method will create a session cookie]
   * @param  {[string]} path    [cookie path(optional): default path will be "/", if not passed explicitly]
   * @param  {[string]} domain  [cookie domain(optional): default domain will be current domain, if not passed explicitly]
   */
  createCookie(name, value, days, path, domain) {
    /* istanbul ignore if */
    if (typeof document === 'undefined' || name.length === 0) {
      return;
    }
    const cookieArray = [];
    /* istanbul ignore if */
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      cookieArray.push('expires=' + date.toGMTString());
    }

    cookieArray.push('path=' + (typeof path !== 'undefined' ? path : '/'));
    if (typeof domain !== 'undefined') {
      cookieArray.push('domain=' + domain);
    }

    document.cookie = name + '=' + value + '; ' + cookieArray.join('; ');
  },

  /**
   * Create a new cookie or update an existing cookie with Domain
   * @param  {[string]} cName    [cookie name]
   * @param  {[string]} cValue   [cookie value]
   * @param  {[string]} path     [cookie path(optional): default path will be "/", if not passed explicitly]
   * @param  {[string]} domain   [cookie domain(optional): default domain will be current domain, if not passed explicitly]
   */
  createCookiewithSubDomain(cName, cValue, path, domain, expires) {
    document.cookie = `${cName}=${cValue};path=${path};domain=${domain}${expires ? `;${expires}` : ''}`;
  },

  /**
   * create sub doamin Name
   * @returns sub doamin Name
   */
  createSubDomainName() {
    let host = document.location.hostname;
    let domainParts, domain;
    if (host.split('.').length > 1) {
      domainParts = host.split('.');
      domainParts.shift();
      domain = '.' + domainParts.join('.');
    }
    return domain;
  },
  /**
   * Return locale specific switch flag to turn off/on functionality
   * @param  {[string]} name    [cookie name]
   * @return {[string]} domain  [returns the value of a cookie. If cookies doesn't exist, returns null.]
   */
  getLocaleSwitches(localeData, siteConfigData, switchRequired) {
    let flag = false;
    if (
      localeData &&
      localeData.selectedCountry &&
      localeData.selectedCountry.code &&
      siteConfigData
    ) {
      const currentsiteConfig = siteConfigData[localeData.selectedCountry.code];
      flag = currentsiteConfig.switches[switchRequired];
    }
    return flag;
  },
  /**
   * Read the value of an existing cookie
   * @param  {[string]} name    [cookie name]
   * @return {[string]} domain  [returns the value of a cookie. If cookies doesn't exist, returns null.]
   */
  readCookie(name) {
    /* istanbul ignore if */
    if (typeof document === 'undefined') {
      return null;
    }
    if (name.length === 0) {
      return null;
    }
    const cName = name + '=';
    const cArray = document.cookie.split(';');
    let cACount = cArray.length;
    /* istanbul ignore next */
    while (cACount) {
      cACount--;
      let c = cArray[cACount];
      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length);
      }
      if (c.indexOf(cName) === 0) {
        return c.substring(cName.length, c.length);
      }
    }

    return null;
  },
  /**
   * Requests an anonymous session cookie for guest users who don't have one yet
   * @param  {[object]} user  [logged-in user object, if any]
   */
  async ensureAnonymousSession(user) {
    const isLoggedIn = !!(user?.emailId || user?.profileId);
    if (isLoggedIn) {
      return;
    }
    try {
      CommonUtil.showApplicationLoader();
      await fetch(
        `/gr-bff/v1/commerce/user/anonymous?brand=${CommonUtil.getBrand()}`,
        { method: 'GET', headers: {} },
      );
    } catch (error) {
      console.error("[/gr-bff/v1/commerce/user/anonymous] Request failed:", error);
    } finally {
      CommonUtil.hideApplicationLoader();
    }
  },
  /**
   * Delete an existing cookie
   * @param  {[string]} name    [cookie name]
   * @param  {[string]} domain    [domain for which the cookie is to be deleted]
   */
  deleteCookie(name, domain) {
    if (name.length === 0) {
      return;
    }
    this.createCookie(name, '', -1, '/', domain);
  },
  sentenceCase(str) {
    if (str && typeof str === 'string') {
      const newStr = str.toString();
      return newStr.replace(
        /\w\S*/g,
        (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(),
      );
    }
    return str;
  },
  validateTextInput(validationFuncsWithErrorMsg, control, errorAttributes) {
    if (!Array.isArray(validationFuncsWithErrorMsg)) {
      return false;
    }
    if (!errorAttributes) {
      errorAttributes = { controlErrorClass: 'error', errorClass: 'error' };
    }
    let isControlValueValid = true;
    let errorFunctionIndex = 0;
    for (let index = 0; index < validationFuncsWithErrorMsg.length; index++) {
      const validationObject = validationFuncsWithErrorMsg[index];
      if (!typeof validationObject.functionRef === 'function') {
        return false;
      }
      errorFunctionIndex = index;
      isControlValueValid = validationObject.functionRef.apply(
        null,
        validationObject.funcData,
      );
      if (!isControlValueValid) {
        break;
      }
    }
    control.setControlState(
      isControlValueValid,
      validationFuncsWithErrorMsg[errorFunctionIndex].errorMessage,
      errorAttributes,
    );
    return isControlValueValid;
  },

  validateSelecteTab(validationFuncsWithErrorMsg, control, errorAttributes) {
    if (!errorAttributes) {
      errorAttributes = { controlErrorClass: 'error', errorClass: 'error' };
    }
    if (!typeof validationFuncsWithErrorMsg.functionRef === 'function') {
      return false;
    }
    let isControlValueValid = true;
    isControlValueValid = validationFuncsWithErrorMsg.functionRef.apply(
      null,
      validationFuncsWithErrorMsg.funcData,
    );
    control.setControlState(
      isControlValueValid,
      validationFuncsWithErrorMsg.errorMessage,
      errorAttributes,
    );
    return isControlValueValid;
  },

  validateCalendarInput(validationFuncsWithErrorMsg, control, errorAttributes) {
    if (!errorAttributes) {
      errorAttributes = { controlErrorClass: 'error', errorClass: 'error' };
    }
    if (!typeof validationFuncsWithErrorMsg.functionRef === 'function') {
      return false;
    }
    let isControlValueValid = true;
    isControlValueValid = validationFuncsWithErrorMsg.functionRef.apply(
      null,
      validationFuncsWithErrorMsg.funcData,
    );
    control.setControlState(
      isControlValueValid,
      validationFuncsWithErrorMsg.errorMessage,
      errorAttributes,
    );
    return isControlValueValid;
  },

  validateSelectedValue(str) {
    if (str <= 0) {
      return false;
    }
    return true;
  },

  copyToClipBoard(text) {
    if (window.clipboardData && window.clipboardData.setData) {
      return clipboardData.setData('Text', text);
    } else if (
      document.queryCommandSupported &&
      document.queryCommandSupported('copy')
    ) {
      let textarea = document.createElement('textarea');
      textarea.textContent = text;
      textarea.style.position = 'fixed'; // Prevent scrolling to bottom of page in MS Edge.
      document.body.appendChild(textarea);
      textarea.select();

      try {
        return document.execCommand('copy');
      } catch (ex) {
        console.warn('Copy to clipboard failed.', ex);
        return false;
      } finally {
        document.body.removeChild(textarea);
      }
    }
  },

  /* eslint-disable */
  /*
    Please do not change these configration. We need to test following logic.
  */
  getChannel() {
    // return serverClientUtil.getChannel();
    // return 'wap';
    // TODO: Logic needs to be updated here to send the actual channel
    let _channel = serverClientUtil.getChannel();
    if (
      typeof window !== 'undefined' &&
      typeof navigator !== 'undefined' &&
      _channel.trim().length == 0
    ) {
      serverClientUtil.setChannel(navigator.userAgent);
      _channel = serverClientUtil.getChannel();
    }
    return _channel;
    // return 'web';
    // return 'wap';
    // return 'store';
  },

  getUserAggent() {
    let agentDetails = {
      isDesktop: false,
      isIpad: false,
      isMobile: false,
      isAndroid: false,
    };

    if (typeof window !== 'undefined' && typeof navigator !== 'undefined') {
      if (navigator.userAgent != '') {
        if (
          navigator.userAgent.match(/Android/i) ||
          navigator.userAgent.match(/iPhone/i)
        ) {
          agentDetails.isMobile = true;
          if (navigator.userAgent.match(/Android/i)) {
            agentDetails.isAndroid = true;
          }
        } else if (
          navigator.userAgent.match(/iPad/i) ||
          navigator.userAgent.match(/iPod/i)
        ) {
          agentDetails.isIpad = true;
        } else {
          agentDetails.isDesktop = true;
        }
      }
    } else {
      agentDetails.isDesktop = true;
    }

    let vozClienteStyle =
      (agentDetails.isAndroid && agentDetails.isMobile) ||
      agentDetails.isDesktop
        ? 'container_button_vozcliente'
        : 'container_button_vozcliente_ios';

    return vozClienteStyle;
  },

  getBrand() {
    return serverClientUtil.getBrand();
    // return 'LP';
  },

  getCurrentBrandColors() {
    const currentBrand = this.getBrand();
    switch (currentBrand) {
      case 'LP':
        return { primary: '#E10098' };
      case 'GAP':
        return { primary: '#122344' };
      case 'PB':
        return { primary: '#970400' };
      case 'PBK':
        return { primary: '#74b0e2' };
      case 'WS':
        return { primary: '#e81818' };
      case 'WLM':
        return { primary: '#ed2724' };
      case 'TRU':
        return { primary: '#007bff' };
      default:
        throw new Error(`Brand ${currentBrand} does not have colors assigned`);
    }
  },

  getAppBaseURL() {
    let _baseURL = serverClientUtil.getAppBaseURL();
    // if (typeof window !== "undefined" && _baseURL && _baseURL.trim() && _baseURL.trim().length == 0) {
    if (typeof window !== 'undefined' && _baseURL.trim().length == 0) {
      serverClientUtil.setAppBaseURL(window.location.href);
      _baseURL = serverClientUtil.getAppBaseURL();
    }
    return _baseURL;
    // return 'http://localhost:3000'
  },

  // Returns application URL along with channel for fething assets specific to web/wap
  getAssetURL() {
    return this.getAppBaseURL() + '/' + this.getChannel();
  },

  attachWapBackClickHandler() {
    return AppEvents.subscribe(
      AppEvents.EVENT_REGISTER.WAP_BACK_BUTTON_CLICKED,
    );
  },
  publishWapBackClickHandler(uniqueKeyForEvent, func) {
    if (
      func &&
      typeof func === 'function' &&
      this.getChannel() === defaultConst.constChannel.WAP
    ) {
      AppEvents.publish(uniqueKeyForEvent, [func]);
    }
  },
  detachWapBackClickHandler(uniqueKeyForEvent) {
    AppEvents.unsubscribe(uniqueKeyForEvent);
  },
  defaultBrowserBackClick() {
    if (browserHistory) {
      browserHistory.goBack();
    }
  },
  /* eslint-enable */

  downloadPrint(param, pageName, fileName, callBack) {
    let winPop = null;
    if (param && param === constDownload) {
      if (pageNameTableOrg === pageName) {
        winPop = window.popup = window.open(
          this.routeTo(applicationRoutes.downloadToPDF, [
            { pageName },
            { content: param },
            { fileName },
          ]),
          '_blank',
          'scrollbars=yes,width=auto,height=auto',
        );
      } else {
        winPop = window.popup = window.open(
          this.routeTo(applicationRoutes.downloadToPDF, [
            { pageName },
            { content: param },
            { fileName },
          ]),
          '_blank',
          'scrollbars=yes,width=' +
            (screen.width - 100) +
            ',height=' +
            (screen.height - 100),
        );
      }
    } else if (param && param === constPrint) {
      winPop = window.popup = window.open(
        this.routeTo(
          applicationRoutes.downloadToPDF,
          [{ pageName }, { content: param }, { fileName }],
          '_blank',
          'height=400,width=600',
        ),
      );
    }
    if (winPop) {
      winPop.onload = function () {
        callBack &&
          setTimeout(() => {
            callBack();
          }, 500);
      };
    }
  },
  downloadPdf(elem, fileName, orientation) {
    setTimeout(() => {
      this.generatePdf(
        elem,
        fileName,
        (pdf) => {
          if (pdf) {
            pdf.save(fileName);
          }
        },
        orientation,
      );
    }, 500);
  },
  downloadPdfWithoutPreview(
    elem,
    fileName,
    callBack,
    orientation,
    pageName,
    isNewWindow = false,
  ) {
    const timeOut = pageName === 'tableOrganizer' ? 2500 : 500;
    setTimeout(() => {
      this.generatePdf(
        elem,
        fileName,
        (pdf) => {
          if (pdf) {
            var isIOSDevice =
              !!navigator.platform &&
              /iPad|iPhone|iPod/.test(navigator.platform);
            if (isIOSDevice) {
              //pdf.output('dataurl');
              //window.open(pdf.output('bloburl'), '_blank');
              if (isNewWindow) {
                callBack(pdf.output('bloburl'));
              } else {
                pdf.output('dataurl');
              }
            } else {
              pdf.save(fileName);
            }
            if (callBack && typeof callBack === 'function') {
              callBack(pdf.output('bloburl'));
            }
          }
        },
        orientation,
      );
    }, timeOut);
  },
  mailPdf(elem, fileName, callBack, orientation, pageName) {
    const timeOut = pageName === 'tableOrganizer' ? 500 : 500;
    setTimeout(() => {
      if (typeof callBack === 'function') {
        this.generatePdf(
          elem,
          fileName,
          (pdf) => {
            if (pdf) {
              callBack(fileName, pdf.output('blob'));
            }
          },
          orientation,
        );
      }
    }, timeOut);
  },
  generatePdf(ctlToPrint, fileName, callBack, orientation = 'p') {
    // const html2canvas = require('html2canvas');  // eslint-disable-line no-unused-vars
    // const jsPDF = require('jspdf');
    // if (typeof window !== 'undefined'){
    //   window.html2canvas = html2canvas;
    // }
    const input = document.querySelector(ctlToPrint);
    const pdf = new jsPDF(orientation, 'px', 'letter');
    pdf.internal.scaleFactor = 2.25;
    const x = fileName.includes('event-messages') ? 0 : 20;
    const top = fileName.includes('event-messages') ? 0 : 10;
    const bottom = fileName.includes('event-messages') ? 0 : 10;

    /*  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
    const originalBodyStyle = document.body.getAttribute("style") || "";

    document.body.style.position = "fixed";
    document.body.style.top = `-${scrollTop}px`;
    document.body.style.left = `-${scrollLeft}px`;
    document.body.style.right = "0";
    document.body.style.overflow = "hidden"; */

    if (input) {
      pdf.addHTML(
        input,
        x,
        0,
        {
          pagesplit: true,
          useCORS: true,
          margin: {
            top: top,
            bottom: bottom,
            useFor: 'page',
          },
        },
        function () {
          // document.body.setAttribute("style", originalBodyStyle);
          // window.scrollTo(scrollLeft, scrollTop);
          if (callBack) {
            callBack(pdf);
          }
        },
      );
    }
  },

  getServiceContextPath(options) {
    if (
      typeof window !== 'undefined' &&
      typeof window.localeContextPath !== 'undefined'
    ) {
      return window.localeContextPath;
    } else if (typeof global !== 'undefined') {
      return options.headers ? options.headers.localeContextPath : '';
    }
    return '';
  },

  formatUrl(path) {
    let adjustedPath = '';
    let protocall = process.env.TLS_ENABLE === 'true' ? 'https://' : 'http://';
    if (path && path.indexOf(protocall) < 0) {
      // TODO: need to test with https & //grdev.liverpool.com.mx
      adjustedPath = path[0] !== '/' ? `/${path}` : path;
    } else {
      adjustedPath = path;
    }

    if (SERVER && path.indexOf(protocall) < 0) {
      return `${
        protocall + process.env.HOST || 'localhost'
      }:${port}${adjustedPath}`;
    }
    // Prepend `/api` to relative URL, to proxy to API server.
    return adjustedPath;
  },

  async triggerServerRequestOld(options, res) {
    const startTime = new Date().getTime();
    let body = undefined;
    // options.url = CommonUtil.getServiceContextPath(options) + options.url;
    options.url = CommonUtil.formatUrl(options.url);

    const config = {
      method: 'GET',
      url: '/',
      json: true,
      headers: {
        'x-correlation-id': uuid(Date.now()),
      },
    };
    if (!options.headers) {
      delete options.headers;
    }
    Object.assign(config, options);
    try {
      const _return = axios(config);

      const endTime = new Date().getTime();
      const delta = endTime - startTime;
      if (delta > 500) {
        loggerHandler.info(
          { req: config },
          'ALERT!!! commonUtilService call for ',
          config.url,
          ' params : ',
          JSON.stringify(config.params),
          ' took : ',
          endTime - startTime,
          ' milliseconds',
        );
      }
      body = _return.data;
    } catch (e) {
      body = {};
      body.status = constAPIFailure;
      body.errorCode = '002';
      body.msg = e;
    }

    return body;
  },

  async triggerServerRequest(options, res) {
    const _url = options.url;
    const ingnorList = [
      'getStatementDetailsForPrintAndDownload',
      'sendMail',
      'kaltura.com',
    ];
    if (ingnorList.map((p) => _url.indexOf(p) > 0).indexOf(true) === -1) {
      CommonUtil.showApplicationLoader();
    }

    const startTime = new Date().getTime();
    // options.url = CommonUtil.getServiceContextPath(options) + options.url;
    options.url = CommonUtil.formatUrl(options.url);
    console.log('options.url====', options.url);
    const _return = new Promise(async (resolve, reject) => {
      const config = {
        method: 'GET',
        url: '/',
        json: true,
        headers: {
          'Content-Type': 'application/json;charset=utf8',
        },
      };

      if (!options.headers) {
        delete options.headers;
      }

      Object.assign(config, options);
      await axios(config)
        .then((response) => {
          const endTime = new Date().getTime();
          const delta = endTime - startTime;

          if (delta > 500) {
            loggerHandler.info(
              {
                url: config.url,
                method: config.method,
                params: config.params,
              },
              `ALERT! ${config.url} took ${delta}ms`,
            );
          }

          if (ingnorList.every((p) => !_url.includes(p))) {
            CommonUtil.hideApplicationLoader();
          }
          // For Kalture File Upload
          const isKaltura = response?.request?.responseURL
            ?.toLowerCase()
            .includes('kaltura');
          if (isKaltura) {
            return resolve({ body: response.data });
          }

          const responseBody = response.data || {};
          responseBody.status = {
            status:
              response.status >= 200 && response.status <= 204
                ? 'success'
                : 'failure',
          };

          return resolve({ body: responseBody });
        })
        .catch((errorObj) => {
          if (ingnorList.every((p) => !_url.includes(p))) {
            CommonUtil.hideApplicationLoader();
          }

          loggerHandler.error(
            {
              url: config?.url,
              method: config?.method,
              errorMessage: errorObj?.message,
              statusCode: errorObj?.response?.status,
            },
            'commonUtilService Server request error',
          );

          const responseBody = errorObj?.response?.data || {};
          let errorResponse = {
            status: 'failure',
            errorCode: errorObj?.response?.data?.status || 500,
            errorMessage: errorObj?.response?.data?.detail || 'Unknown error',
          };

          return reject({ body: { ...responseBody, ...errorResponse } });
        });
    });
    return _return;
  },
  showApplicationLoader() {
    if (typeof window !== 'undefined' && window.document !== undefined) {
      document.getElementById('loading')
        ? (document.getElementById('loading').style.display = 'block')
        : '';
    }
  },
  hideApplicationLoader() {
    if (typeof window !== 'undefined' && window.document !== undefined) {
      document.getElementById('loading')
        ? (document.getElementById('loading').style.display = 'none')
        : '';
    }
  },
  getClosestElement(el, elePointer) {
    if (elePointer.charAt(0) == '#') {
      do {
        if (el.id === elePointer.substr(1)) {
          return el;
        }
      } while ((el = el.parentNode));
    } else if (elePointer.charAt(0) === '.') {
      do {
        if (el.classList.contains(elePointer.substr(1))) {
          return el;
        }
      } while ((el = el.parentNode));
    } else {
      // this is necessary since nodeName is always in upper case
      elePointer = elePointer.toUpperCase();
      do {
        if (el.nodeName === elePointer) {
          return el;
        }
      } while ((el = el.parentNode));
    }
    return null;
  },

  IsJsonString(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  },
  getServerCurrentDate(serverInfo) {
    if (serverInfo) {
      return new Date(serverInfo.time);
    } else {
      return undefined;
    }
    // Add prop as info: state.info,
    // CommonUtil.getServerCurrentDate(this.props.info.data);
  },
  formatInvitationDate(date) {
    // Converting yyyy-mm-dd to dd-mm-yyyy else return original date
    if (date && date.indexOf('-') > -1) {
      let tDate = date;
      tDate = tDate.split('-');
      return tDate[2] + '/' + tDate[1] + '/' + tDate[0];
    }
    return date;
  },
  formatDate(date, format) {
    if (date) {
      let _output = '';
      let _date = +date;

      // if (isNaN(date)) {
      //   _date = new Date(date);
      // } else {
      //   _date = new Date(parseInt(date));
      // }

      // Check .getTime()/full string format condition
      if (_date) {
        _date = new Date(_date);
      } else {
        if (date.indexOf(':') > -1) {
          var t = date.split(/[- :]/);
          _date = new Date(+t[0], +t[1] - 1, +t[2], +t[3], +t[4], +t[5]);
        } else {
          _date = new Date(date);
        }
      }

      if (format === 'dd/mm/yyyy') {
        _output =
          String(_date.getDate()).padStart(2, '0') +
          '/' +
          String(_date.getMonth() + 1).padStart(2, '0') +
          '/' +
          _date.getFullYear();
      } else if (format === 'time') {
        _output = _date.getTime();
      } else if (format === 'hour12') {
        _output = _date.toLocaleString('en-US', {
          hour: 'numeric',
          hour12: true,
        });
      } else if (format === 'hour24') {
        _output = _date.toLocaleString('en-US', {
          hour: 'numeric',
          hour12: false,
        });
      } else if (format === 'monthName') {
        const spanishMonths = [
          'enero',
          'febrero',
          'marzo',
          'abril',
          'mayo',
          'junio',
          'julio',
          'agosto',
          'septiembre',
          'octubre',
          'noviembre',
          'diciembre',
        ];
        _output =
          _date.getDate() +
          ' ' +
          spanishMonths[_date.getMonth()] +
          ' del ' +
          _date.getFullYear();
      }
      return _output;
    }
  },
  formatServiceDate(date) {
    if (date) {
      let _output = date.split('/');
      let output = undefined;
      if (_output.length === 3) {
        output = _output[1] + '/' + _output[0] + '/' + _output[2];
      }
      return output;
    }
    return date;
  },
  isEmpty(obj) {
    if (obj) {
      return Object.keys(obj).length === 0;
    }
    return false;
  },

  formattingDate(date){
      let formattedDate = "";
      if (date && typeof date === "string" && date.includes("-")) {
          const [year, month, day] = date.split("-");
          if (year && month && day) {
              formattedDate = `${day}/${month}/${year}`;
          }
      }
      return formattedDate;
    },
    
  isObjectEmpty(obj) {
    for (var prop in obj) {
      if (obj.hasOwnProperty(prop)) return false;
    }
    return true;
  },
  getRouteByParameter(route, routeParams) {
    // TODO: need to revisit the logic
    const isDynamicRoute = route && route.indexOf('(') >= 0;
    let routeParameters = [];
    let applicationRoute = isDynamicRoute
      ? route.substr(0, route.indexOf('('))
      : route;
    if (isDynamicRoute) {
      if (!routeParams || this.isEmpty(routeParams)) {
        return route;
      } else {
        routeParameters = route
          .substring(route.indexOf('/:') + 2, route.indexOf(')'))
          .split('/:');
        routeParameters.forEach((param) => {
          applicationRoute += '/';
          applicationRoute += routeParams[param];
        });
      }
    } else {
      applicationRoute = route;
    }
    return applicationRoute;
  },
  getApplicationRoutes() {
    return applicationRoutes;
  },
  getClientConstForChannel() {
    return constChannel;
  },
  ValidateIPaddress: (ipaddress) => {
    if (
      /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
        ipaddress,
      )
    ) {
      return true;
    }
    // alert("You have entered an invalid IP address!")
    return false;
  },
  isAccountSystemAvailable(start, end, current) {
    if (start && end) {
      const startHours = new Date(+start).getHours();
      const startMinutes = new Date(+start).getMinutes();

      const endHours = new Date(+end).getHours();
      const endMinutes = new Date(+end).getMinutes();

      const currentHours = new Date(+current).getHours();
      const currentMinutes = new Date(+current).getMinutes();

      const startValue = +(startHours + ('0' + startMinutes).slice(-2));
      const endValue = +(endHours + ('0' + endMinutes).slice(-2));
      const currentValue = +(currentHours + ('0' + currentMinutes).slice(-2));

      // if (currentValue >= startValue && currentValue <= endValue) {
      //   return true;
      // }

      if (startValue < endValue) {
        if (currentValue >= startValue && currentValue <= endValue) {
          return true;
        }
      } else {
        if (
          (currentValue >= 0 && currentValue <= endValue) ||
          (currentValue >= startValue && currentValue <= 2359)
        ) {
          return true;
        }
      }
    }
    return false;
  },
  getUniqueKey(optionalKey, isPrefix) {
    if (optionalKey && isPrefix) {
      return uniqid(optionalKey + '_');
    } else if (optionalKey && !isPrefix) {
      return uniqid() + '_' + optionalKey;
    } else {
      return uniqid();
    }
  },
  documentClickHandler(e) {
    const elementClicked = e.target;
    let clickIdentifier = elementClicked.id;
    if (clickIdentifier) {
      return clickIdentifier;
    }
    return null;
  },
  goToTop() {
    window.scrollTo({
      top: 100,
      left: 100,
      behavior: 'smooth',
    });
  },
  removeTransition() {
    if (typeof document === 'undefined') {
      return;
    }
    const element = document.querySelector('.container-fluid');
    if (element) {
      element.classList.remove('containerAnimation');
    }
  },
  addTransition() {
    if (typeof document === 'undefined') {
      return;
    }
    if (
      document.querySelector('.container-fluid') &&
      document.querySelector('.container-fluid').classList &&
      document
        .querySelector('.container-fluid')
        .classList.contains('containerAnimation')
    ) {
      this.removeTransition();
    }
    const element = document.querySelector('.container-fluid');
    if (element && this.getChannel() === constChannel.WEB) {
      element.classList.add('containerAnimation');
    }
  },
  getUserInfo(userObject) {
    const _userObject = {};
    _userObject.userId =
      userObject.result.gtmUserId || userObject.result.profileId;
    _userObject.gender = userObject.result.gender;
    if (userObject.result && userObject.result.myEventDetail) {
      _userObject.NoOfEvents = userObject.result.myEventDetail.length;
    }
    return _userObject;
  },
  isBonusAvailable(eventDetailsInfo) {
    const eventcategory = eventDetailsInfo && eventDetailsInfo.eventCategory;
    const creationdate = eventDetailsInfo && eventDetailsInfo.eventCreationDate;
    const creationDateObj = moment(creationdate, 'DD/MM/YYYY');
    const enddate = moment('01/04/2018', 'DD/MM/YYYY');

    if (
      eventcategory === eventCategory.OPENEVENT &&
      creationDateObj.isValid() &&
      creationDateObj.isBefore(enddate)
    ) {
      return true;
    } else if (eventcategory === eventCategory.CELEBRATION) {
      return true;
    }
    return false;
  },
  generateImageCanvas(canvasEl, callBack) {
    html2canvass(canvasEl, {
      scale: 1,
      useCORS: true,
    }).then((canvas) => {
      let counter = 0;
      let parentNode = document.querySelector('#downloadContainer .floor');
      let oldChild = document.querySelector(
        '#downloadContainer .floor .dropArea',
      );
      let newChild = document.createElement('div');
      newChild.className = 'dropArea';
      newChild.style.cssText = 'width: 1200px;height: auto;';
      let canvasToImage = new Image();
      canvasToImage.src = canvas.toDataURL('image/svg');
      newChild.appendChild(canvasToImage);
      parentNode.replaceChild(newChild, oldChild);
      callBack();
    });
  },
  clearBrowserHistoryState(pathname) {
    // clear state.someValue from history
    browserHistory.replace({
      pathname,
      state: {},
    });
  },
  getSocialMediaInfo(socialMediaInfo) {
    let info = {
      actualDate: '',
      id: '',
      name: '',
    };
    let compare = '_lastUpdate';
    for (let i in socialMediaInfo) {
      if (i.indexOf(compare) > -1) {
        if (info.actualDate === '') {
          info.name = socialMediaInfo[i.slice(0, i.indexOf(compare))]
            ? i.slice(0, i.indexOf(compare))
            : '';
          info.id = socialMediaInfo[info.name]
            ? socialMediaInfo[info.name]
            : '';
          info.actualDate = new Date(socialMediaInfo[i]);
        } else {
          let actualDateTemp = new Date(socialMediaInfo[i]);
          if (info.actualDate.getTime() < actualDateTemp.getTime()) {
            info.name = socialMediaInfo[i.slice(0, i.indexOf(compare))]
              ? i.slice(0, i.indexOf(compare))
              : '';
            info.actualDate = actualDateTemp;
            info.id = socialMediaInfo[info.name]
              ? socialMediaInfo[info.name]
              : '';
          }
        }
      }
    }
    return info;
  },

  handleAllowOnlyDigit(e) {
    const ctl = e.target.id;
    const limitLength = e.target.maxLength;
    const thisObj = document.querySelector('#' + ctl);
    const keyCode = e.keyCode;
    // backspace, delete, left arrow and right arrow
    if (
      keyCode === 46 ||
      keyCode === 8 ||
      keyCode === 9 ||
      keyCode === 37 ||
      keyCode === 39
    ) {
      return true;
    }
    if ((keyCode >= 48 && keyCode <= 57) || (keyCode >= 96 && keyCode <= 105)) {
      // numbers and numeric keypad
      if (thisObj.value.length > limitLength) {
        e.preventDefault();
        e.stopPropagation();
      }
    } else {
      e.preventDefault();
      e.stopPropagation();
    }
    return true;
  },
  isValueAvailable(str) {
    if (str && str.trim()) {
      return true;
    }
    return false;
  },
  convertSpanishToEnglishChars(str) {
    const normalizedStr = str.normalize('NFD');
    const withoutDiacritics = normalizedStr.replace(/[\u0300-\u036f]/g, '');
    const finalStr = withoutDiacritics.replace(/ñ/g, 'n').replace(/Ñ/g, 'N');
    return finalStr;
  },
  generateRandomId() {
    return Math.random().toString(36).substring(2, 15);
  },

  handleRedirect(isBuyNow = false) {
    let url = `/api/profile/login?brand=${CommonUtil.getBrand()}`;
    if (isBuyNow) {
      url += '&isBuyNow=true';
    }
    fetch(url, {
      method: 'GET',
      headers: {},
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((result) => {
        if (result.redirect) {
          window.location.href = result.redirect;
        }
        if (result.atg === true) {
          this.handleLoginWithATGAuth0();
        }
      })
      .catch((error) => {
        console.log('-----error========', error);
      });
  },

  checkImageURLFormat(url) {
    if (typeof url !== 'string') {
      return false;
    }
    const imageRegex = /\.(jpg|jpeg|png|gif|bmp|webp|tiff|svg)(\?.*)?$/i;

    if (url.includes('/events/') && !url.includes('undefined')) {
      return false;
    }
    
    return imageRegex.test(url);
  },

  getFavicons(brand) {
    switch (brand) {
      case 'LP':
        return '/favicons/favicon_LP.ico';
      case 'GAP':
        return '/favicons/favicon_GAP.ico';
      case 'PB':
        return '/favicons/favicon_PB.ico';
      case 'PBK':
        return '/favicons/favicon_PBK.ico';
      case 'WS':
        return '/favicons/favicon_WS.ico';
      case 'WLM':
        return '/favicons/favicon_WLM.ico';
      case 'TRU':
        return '/favicons/favicon_TRU.ico';
      default:
        return '/favicons/favicon_LP.ico';
    }
  },

  generateSeoFriendlyUrl(title) {
    return title
      .toString() // Ensure the input is treated as a string
      .normalize('NFD') // Decompose diacritics (e.g., é becomes e)
      .replace(/[\u0300-\u036f]/g, '') // Remove diacritical marks
      .toLowerCase() // Convert the string to lowercase
      .trim() // Remove leading/trailing whitespace
      .replace(/\s+/g, '-') // Replace spaces with single hyphens
      .replace(/[^\w-]+/g, '') // Remove all non-word characters except hyphens
      .replace(/--+/g, '-') // Replace multiple hyphens with a single hyphen
      .replace(/^-+/, '') // Remove leading hyphens
      .replace(/-+$/, ''); // Remove trailing hyphens
  },

  objectToQueryParams(obj) {
    const params = [];
    for (const key in obj) {
      if (Object.hasOwnProperty.call(obj, key)) {
        const value = obj[key];
        // Encode both key and value to handle special characters
        params.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
      }
    }
    return params.join('&');
  },
  handleLoginWithATGAuth0(redirectBackURL = '') {    
    const url = serverClientUtil.getATGLoginURL();
    const redirectUrl = 'https:' + url + '/login';
    const redirectBackUrl = redirectBackURL ? redirectBackURL : window.location.origin;

    const ecommLogintURL = `${redirectUrl}?redirectAfterLoginHref=${redirectBackUrl}&originalRedirectHref=${window.location.origin}`;

    window.location.replace(ecommLogintURL);
  },
  getBrowserIdForRuc() {
    let agent =
      window && window.navigator && window.navigator.userAgent.toLowerCase();
    switch (true) {
      case agent.indexOf('edge') > -1 ||
        agent.indexOf('edg/') > -1 ||
        agent.indexOf('edgios') != -1:
        return '05';
      case agent.indexOf('opr') > -1 && !!window.opr:
        return '03';
      case agent.indexOf('opios') > -1:
        return '03';
      case agent.indexOf('chrome') > -1 && !!window.chrome:
        return '02';
      case agent.indexOf('CriOS') > -1 || agent.indexOf('crios') != -1:
        return '02';
      case agent.indexOf('firefox') > -1 || agent.indexOf('fxios') != -1:
        return '01';
      case agent.indexOf('safari') > -1:
        return '04';
      case agent.indexOf('msie') != -1 ||
        agent.indexOf('ie') != -1 ||
        agent.indexOf('trident') > -1:
        return '06';
      default:
        return '00';
    }
  },
  getBrandLogoPathforPDF() {
    const brand = CommonUtil.getBrand();
    let path = '';
    switch (brand) {
      case 'LP':
        path =
          'https://gcp-na-images.contentstack.com/v3/assets/blteb5bbf1ff258863a/blt6418e1fbab3f913c/6a2a77d38461368423e3b868/logo-lp-new.svg?branch=qa';
        break;
      case 'PB':
        path =
          'https://gcp-na-images.contentstack.com/v3/assets/blteb5bbf1ff258863a/bltec716a19ef7f9292/698df37fabd69abcb235d9a1/logo-pb.png?branch=qa';
        break;
      case 'PBK':
        path =
          'https://gcp-na-images.contentstack.com/v3/assets/blteb5bbf1ff258863a/blt55cf1334eb247307/698df37f47ca387ad63c7d4c/logo-pbk.png?branch=qa';
        break;
      case 'GAP':
        path =
          'https://gcp-na-images.contentstack.com/v3/assets/blteb5bbf1ff258863a/bltc1ba3bbe2ce008db/698df37f457a5270f2d7491f/logo-gap.png?branch=qa';
        break;
      case 'WLM':
        path =
          'https://gcp-na-images.contentstack.com/v3/assets/blteb5bbf1ff258863a/blt9edc63ded61c86ad/698df37f77c52863b45a5799/logo-wlm.png?branch=qa';
        break;
      case 'WS':
        path =
          'https://gcp-na-images.contentstack.com/v3/assets/blteb5bbf1ff258863a/bltc2ed7f22b209198a/698df37f77c528c17c5a579d/logo-ws.png?branch=qa';
        break;
      case 'TRU':
        path =
          'https://gcp-na-images.contentstack.com/v3/assets/blteb5bbf1ff258863a/bltd3cf62561baca39c/698df37f47ca3876a73c7d4a/logo-tru.png?branch=qa';
        break;
      default:
        break;
    }
    return path;
  },
  getImageMeta() {
    const mesaDeRegalosLogo =
      process.env.MESA_DE_REGALOS_LOGO ||
      'https://gcp-na-images.contentstack.com/v3/assets/blteb5bbf1ff258863a/blt1a99acc4a8368f14/6a323602cef1453d6098fb68/mesa-de-regalos.png?branch=qa' ||
      this.getAssetURL() + '/images/mesa-de-regalos.png';
    const mesaDeRegalosLogoWhite = 'https://gcp-na-images.contentstack.com/v3/assets/blteb5bbf1ff258863a/blt76680eb04b09397f/6a32ccfa90e79da7e263777a/mesa-de-regalos-white.png?branch=qa';
    const LpLogoWhite = 'https://gcp-na-images.contentstack.com/v3/assets/blteb5bbf1ff258863a/bltd3218a69293e2240/6a6051536b897442e590cc08/lp_logo_white.png?branch=qa'
    return {
      mesaDeRegalosLogo,
      mesaDeRegalosLogoWhite,
      LpLogoWhite
    };
  },
};

export default CommonUtil;

// TODO : To check whether "es-lint disable" should be done or not....
